//
export default function errorReducer(error, path) {
  if (!error) return [];
  // Form-level only: same axios "Network Error" was shown under every field
  // (email, password, meta) because this branch ignored `path`.
  if (error.message === 'Network Error') {
    if (path !== 'meta') return [];
    return [
      {
        code: 'network',
        message:
          "We can't reach Birdi from your device. Check your internet connection and try again.",
      },
    ];
  }
  // express-rate-limit answers 429 with a plain-text body, so there is no
  // {code, message} to show and the user got the generic fallback.
  if (error.name === 'APIError' && error.status === 429) {
    if (path !== 'meta') return [];
    return [
      {
        code: 'rate_limited',
        message:
          'Too many attempts from your network. Wait a few minutes and try again.',
      },
    ];
  }
  if (error.name === 'APIError') {
    // Handle multiple errors
    if (Array.isArray(error.body)) {
      return error.body.filter((err) => err.path === path);
    }
    // Handle single errors
    if (path === 'meta') {
      return [
        {
          code: error.body.code,
          message: error.body.message,
        },
      ];
    }
  }
  // TODO: Handle generic errors
  if (path === 'meta') return [{ code: 'generic' }];
  return [];
}
